import { render, staticRenderFns } from "./results-board.vue?vue&type=template&id=5712549e&scoped=true&"
import script from "./results-board.vue?vue&type=script&lang=ts&"
export * from "./results-board.vue?vue&type=script&lang=ts&"
import style0 from "./results-board.vue?vue&type=style&index=0&id=5712549e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712549e",
  null
  
)

export default component.exports